// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bo-core/grids/RolesGrid/rolesGrid.css
// module id = 773
// module chunks = 1